module.exports = __webpack_public_path__ + "static/img/team-img-bg2.995db0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-img-bg2.png
// module id = Z5aZ
// module chunks = 36